import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function ModalForumGroupsComponent({ Close
    , mentors, handleItemSubmit, selectedForumGroups, onInnerBasicFormChange }: any) {


    return (

        <div className="  w-full p-2 bg-white shadow-md rounded-md">
            <h1 className="text-xl font-bold mb-4 text-center">Add Chapters</h1>
            <div className=" grid md:grid-cols-2 lg:grid-cols-3 gap-4 border p-4">
                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Name',

                        )
                    }}
                    type="text"
                    value={selectedForumGroups?.Name}
                />

                <InputContainer
                    label="Description"
                    name="Description"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Description',

                        )
                    }}
                    type="text"
                    value={selectedForumGroups?.Description}
                />
                
                <InputContainer
                    label="Display Order"
                    name="DisplayOrder"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'DisplayOrder',

                        )
                    }}
                    type="number"
                    value={selectedForumGroups?.DisplayOrder}
                />
               


               

                    
            </div>

            <div className="flex justify-end mt-6">
                <button
                    onClick={Close}
                    type="button"
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                >
                    Close
                </button>
                <button
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                    onClick={handleItemSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>

        </div>



    )
}